import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type Variant = 'dark' | 'light' | 'outline' | 'green';
type ArrowButtonProps = {
  to: string;
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
};
const styles: Record<Variant, {
  root: string;
  dot: string;
}> = {
  dark: {
    root: 'bg-ink text-white hover:bg-ink-soft',
    dot: 'bg-leaf text-ink'
  },
  light: {
    root: 'bg-white text-ink hover:bg-canvas',
    dot: 'bg-brand text-white'
  },
  outline: {
    root: 'border border-ink/15 text-ink hover:border-ink/40',
    dot: 'bg-ink text-white'
  },
  green: {
    root: 'bg-leaf text-ink hover:bg-[#9de86b]',
    dot: 'bg-ink text-leaf'
  }
};
export function ArrowButton({
  to,
  children,
  variant = 'dark',
  className = ''
}: ArrowButtonProps) {
  const s = styles[variant];
  return <Link to={to} className={`group inline-flex items-center gap-3 whitespace-nowrap rounded-full py-2 pl-6 pr-2 text-[15px] font-medium transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 ${s.root} ${className}`} data-id="element-242" data-mp="d0mn0w3o3k8c">
      {children}
      <span className={`flex h-9 w-9 items-center justify-center rounded-full transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-0.5 ${s.dot}`} data-id="element-243" data-mp="nmy7emad2m1z">
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="dsxuhy8u8cip" />
      </span>
    </Link>;
}